import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  PageDescription,
  FormGroup,
  Label,
  Input,
  PriceInputGroup,
  ButtonGroup,
  Button,
} from '../PriceListsPage.style';
import { getCurrencySymbol } from '../../../lib/formatCurrency';

const EditTyreModal = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  onFormChange,
}) => {
  const { t } = useTranslation();
  const currencySymbol = getCurrencySymbol();

  if (!isOpen) return null;

  return (
    <Modal>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0 }} />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{t('editTyre')}</ModalTitle>
          {formData.pricelistLabel && (
            <PageDescription>
              {formData.pricelistLabel}
            </PageDescription>
          )}
        </ModalHeader>

        <form onSubmit={onSubmit}>
          <FormGroup>
            <Label htmlFor="edit-dimension">{t('dimension')}</Label>
            <Input
              id="edit-dimension"
              name="dimension"
              type="text"
              value={formData.dimension}
              onChange={(e) => onFormChange('dimension', e.target.value)}
              placeholder={t('dimensionPlaceholder')}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="edit-model">{t('model')}</Label>
            <Input
              id="edit-model"
              name="model"
              type="text"
              value={formData.model}
              onChange={(e) => onFormChange('model', e.target.value)}
              placeholder={t('enterTyreModel')}
              required
            />
          </FormGroup>

          <PriceInputGroup>
            <FormGroup>
              <Label htmlFor="edit-bruto">{t('grossLabel')} ({currencySymbol})</Label>
              <Input
                id="edit-bruto"
                name="bruto"
                type="number"
                step="0.01"
                min="0"
                value={formData.bruto}
                onChange={(e) => onFormChange('bruto', e.target.value)}
                placeholder="0.00"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="edit-neto">{t('netLabel')} ({currencySymbol})</Label>
              <Input
                id="edit-neto"
                name="neto"
                type="number"
                step="0.01"
                min="0"
                value={formData.neto}
                onChange={(e) => onFormChange('neto', e.target.value)}
                placeholder="0.00"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="edit-brutoZPopustom">{t('withDiscountLabel')} ({currencySymbol})</Label>
              <Input
                id="edit-brutoZPopustom"
                name="brutoZPopustom"
                type="number"
                step="0.01"
                min="0"
                value={formData.brutoZPopustom}
                onChange={(e) => onFormChange('brutoZPopustom', e.target.value)}
                placeholder="0.00"
                required
              />
            </FormGroup>
          </PriceInputGroup>

          <ButtonGroup>
            <Button type="button" onClick={onClose}>
              {t('cancel')}
            </Button>
            <Button type="submit" $primary>
              {t('saveChanges')}
            </Button>
          </ButtonGroup>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default EditTyreModal;


